import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { uniqueId } from 'lodash-es';
import { Observable } from 'rxjs';
import { SetOrderConfirmed } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.actions';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent {
  @Input() showCheckbox: boolean = true;
  @Input() isTouched: boolean = false;
  @Input() disabled: boolean = false;

  @Select(OrderWizardDataState.isOrderConfirmed) isOrderConfirmed$!: Observable<boolean>;

  isDirty: boolean = false;
  uuid = uniqueId();

  constructor(private store: Store) {}

  onConfirmChange(value: boolean) {
    this.isDirty = true;
    this.store.dispatch(new SetOrderConfirmed(value));
  }
}
